import clientAxios from './../../config/axios';

export const getAllData = () => {
  const url = `/dashboard/?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.get(url);
};
